module.exports = __webpack_public_path__ + "img/bewell-hero-image.55c8f2c0.jpeg";